import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Currency from 'components/Currency';
import { getThemeName } from 'utils/themeUtils';
import { THEME_WCC } from 'themes';

const Wrapper = styled.div`
  display: flex;
  font-size: ${props => (props.isTotal ? '1.2em' : '1em')};

  h5 {
    margin-bottom: 0;
    font-size: 1em;

    &.name {
      font-weight: ${props => (props.isTax ? 'normal' : props.theme.fontBold)};
    }
  }

  & > div {
    flex: 1 0 auto;
  }

  div:last-child {
    text-align: right;
  }

  p {
    margin-bottom: 0;
  }

  & + & {
    margin-top: 1em;
  }

  .room-details {
    width: 65%;
  }

  .price-original {
    del {
      color: ${props => props.theme.a.color};
      font-weight: normal;
    }
  }
`;

function LineItem({ item, className, isTotal }) {
  // TODO: add a prop type shape for this
  const { quantity, name, details, price, originalPrice } = item;

  return (
    <Wrapper className={className}>
      <div className="room-details">
        <h5 className="name">
          {quantity && quantity + ' '}
          {name}
        </h5>
        {details && details.join(', ')}
      </div>
      <div>
        <h5>
          {originalPrice && (
            <span className="price-original">
              <del>
                <Currency value={originalPrice} />
              </del>
            </span>
          )}
          {getThemeName() === THEME_WCC ? ' ' : <br />}
          {isTotal && price === 0 ? (
            <span>COMP</span>
          ) : (
            price && <Currency value={price} />
          )}
        </h5>
      </div>
    </Wrapper>
  );
}

LineItem.propTypes = {
  className: PropTypes.string,
  isTotal: PropTypes.bool,
  isTax: PropTypes.bool,
  item: PropTypes.shape({
    quantity: PropTypes.number,
    name: PropTypes.string,
    details: PropTypes.arrayOf(PropTypes.string),
    price: PropTypes.number
  })
};

export default LineItem;
